import { KLoggingEventBuilder2t27iqox7tpd3 as KLoggingEventBuilder } from '../KLoggingEventBuilder.mjs';
import { KotlinLoggingConfiguration_getInstance2afdiujdk3hao as KotlinLoggingConfiguration_getInstance } from '../KotlinLoggingConfiguration.mjs';
import { KLoggingEvent3el01063mcenm as KLoggingEvent } from '../KLoggingEvent.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  info3uezdutu3rpr2 as info,
  info2hxv79dt541ps as info_0,
  info2wxw456lwpd2r as info_1,
  error12wpw0xi3o0bs as error,
  error1aa4zvb3h0fa3 as error_0,
  KLogger368y32iihya1v as KLogger,
} from '../KLogger.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KLoggerDirectClass;
function KLoggerDirect() {
  if (KLoggerDirectClass === VOID) {
    class $ {
      constructor(name) {
        this.name_1 = name;
      }
      at_pbp260_k$(level, marker, block) {
        if (this.isLoggingEnabledFor_e9gpvv_k$(level, marker)) {
          // Inline function 'kotlin.apply' call
          var this_0 = new (KLoggingEventBuilder())();
          block(this_0);
          // Inline function 'kotlin.run' call
          if (level.ordinal_1 !== 5) {
            KotlinLoggingConfiguration_getInstance().direct_1.get_appender_ceg5ww_k$().log_1olo2n_k$(KLoggingEvent().new_io_github_oshai_kotlinlogging_KLoggingEvent_tww1re_k$(level, marker, this.name_1, this_0));
          }
        }
      }
      isLoggingEnabledFor_e9gpvv_k$(level, marker) {
        return level.isLoggingEnabled_4z98ks_k$();
      }
    }
    protoOf($).info_x42d1k_k$ = info;
    protoOf($).info_vfab1e_k$ = info_0;
    protoOf($).info_2ddyqe_k$ = info_1;
    protoOf($).error_eo61l4_k$ = error;
    protoOf($).error_uv4ku4_k$ = error_0;
    initMetadataForClass($, 'KLoggerDirect', VOID, VOID, [KLogger()]);
    KLoggerDirectClass = $;
  }
  return KLoggerDirectClass;
}
//region block: exports
export {
  KLoggerDirect as KLoggerDirect1gyffbbrrlqc0,
};
//endregion

//# sourceMappingURL=KLoggerDirect.mjs.map
